import { useCallback, useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import client from './adminApi';
import { Pagination } from './components/ui';

export default function AuditPage() {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);

  const load = useCallback(async () => {
    const res = await client.get('/admin/audit-log', { params: { page, per_page: 50 } });
    setData(res.data);
  }, [page]);

  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-audit">
      <h1 className="text-2xl font-extrabold tracking-tight text-navy-900">Audit Log</h1>
      <p className="mt-1 text-sm text-slate-500">Material administration activity. Passwords and tokens are never recorded.</p>

      {!data ? (
        <div className="flex justify-center py-16" role="status"><Loader2 className="h-6 w-6 animate-spin text-navy-900" /></div>
      ) : data.entries.length === 0 ? (
        <p className="mt-6 rounded-xl border-2 border-dashed border-slate-300 bg-white p-10 text-center text-sm font-semibold text-slate-500">No activity recorded yet.</p>
      ) : (
        <div className="mt-5 overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <table className="w-full min-w-[640px] text-left text-sm">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50 text-xs font-bold uppercase tracking-wide text-slate-500">
                <th scope="col" className="px-4 py-3">When</th>
                <th scope="col" className="px-4 py-3">User</th>
                <th scope="col" className="px-4 py-3">Action</th>
                <th scope="col" className="px-4 py-3">Record</th>
                <th scope="col" className="px-4 py-3">Summary</th>
              </tr>
            </thead>
            <tbody>
              {data.entries.map((e, i) => (
                <tr key={i} className="border-b border-slate-100 last:border-0">
                  <td className="whitespace-nowrap px-4 py-2.5 text-xs text-slate-500">{new Date(e.at).toLocaleString('en-IE')}</td>
                  <td className="px-4 py-2.5 font-semibold text-navy-900">{e.user}</td>
                  <td className="px-4 py-2.5 text-xs font-bold uppercase text-slate-600">{e.action}</td>
                  <td className="px-4 py-2.5 text-xs text-slate-500">{e.recordType} / {e.recordId}</td>
                  <td className="px-4 py-2.5 text-xs text-slate-600">{e.summary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {data && <Pagination page={page} perPage={50} total={data.total} onPage={setPage} />}
    </div>
  );
}
